module.exports = __webpack_public_path__ + "static/media/city-walk.55f9ceaa.jpeg";